module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/legend.6e91450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/legend.jpg
// module id = JSAt
// module chunks = 0